import type * as Blockly from 'blockly/core';
import {
    expr,
    registerHelperFunction,
    registerSetupCode,
    resolveAnalogPin,
} from '@/(routers)/boards/editor/block/generators/arduino/_gen';

const NH3_HELPER = (pin: string) => `float _R0_${pin} = 0.0;
void _sbeNh3Calibrate_${pin}(int pinNumber) {
  float sensorValue = 0.0;
  for (int i = 0; i < 300; i++) {
    sensorValue += analogRead(pinNumber);
    delay(10);
  }
  sensorValue /= 300.0;
  float sensorVolt = sensorValue / 1023.0 * 5.0;
  if (sensorVolt < 0.01) sensorVolt = 0.01;
  float RS = 4700.0 * (5.0 / sensorVolt - 1.0);
  _R0_${pin} = RS / 2.0;
}
float _sbeGetNh3ppm_${pin}(int pinNumber) {
  int sensorValue = analogRead(pinNumber);
  float sensorVolt = (float)sensorValue / 1023.0 * 5.0;
  if (sensorVolt < 0.01) sensorVolt = 0.01;
  float RS = 4700.0 * (5.0 / sensorVolt - 1.0);
  float ratio = RS / _R0_${pin};
  if (ratio <= 0) return 0;
  return 50.0 * pow(ratio / 0.35, 1.0 / -0.63);
}`;

export function register(gen: any): void {
    gen.forBlock['ammonia'] = function (block: Blockly.Block): [string, number] {
        const { pin } = resolveAnalogPin(block);
        const type = block.getFieldValue('TYPE') as 'RAW' | 'PPM';

        registerSetupCode(pin, `  pinMode(${pin}, INPUT);\n`);

        if (type === 'PPM') {
            registerHelperFunction(`ammonia_${pin}`, NH3_HELPER(pin));
            registerSetupCode(`ammonia_calibrate_${pin}`, `  _sbeNh3Calibrate_${pin}(${pin});\n`);
            return expr(`_sbeGetNh3ppm_${pin}(${pin})`);
        }

        return expr(`analogRead(${pin})`);
    };
}
